const Footer = () => {
	return (
		<footer className='container-fluid bg-light p-3 mb-0 shadow border-top'>

		</footer>
	);
};

export default Footer;
